import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import type { RootState } from '../store/configureStore';
import { DevTokenService } from '../services';

/** Token Retrieval code - only for Development use in Local Environment */

const MyCarsTokenRefreshHookForDev = () => {
  const myCarsApiStatus = useSelector(
    (state: RootState) => state.myCars.myCarsAPIStatus
  );

  const updateToken = () => {
    const getToken = async () => {
      await DevTokenService.getDevAccessToken();
    };
    getToken().then(() => {
      window.location.href = '/';
    });
  };

  const checkTokenOnRefresh = (e: any) => {
    const isError: any = document.getElementById('landing-error-msg');
    if (isError) {
      console.log('about to prevent default the refresh and check token');
      e.preventDefault();
      updateToken();
    }
  };

  useEffect(() => {
    if (
      process.env.NODE_ENV === 'test' &&
      process.env.CARVANA_APP_IS_LOCAL_ENVIRONMENT &&
      !(window as any).Cypress
    ) {
      window.addEventListener('beforeunload', checkTokenOnRefresh);
    }
    return () => {
      window.removeEventListener('beforeunload', checkTokenOnRefresh);
    };
  }, []);

  if (
    process.env.NODE_ENV === 'test' &&
    process.env.CARVANA_APP_IS_LOCAL_ENVIRONMENT &&
    !(window as any).Cypress &&
    myCarsApiStatus.isError
  ) {
    updateToken(); // Update token on API error
  }
};

export default MyCarsTokenRefreshHookForDev;
